import { useContext, useMemo, useState, useEffect } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { windowExists } from '../components/Utils';
// See Stencil for more breakpoints.
// https://brand.homedepot.com/site/knapsack-nucleus/latest/pattern/breakpoints?subPageId=Tokens
// [As of 2025] sm: 640px, md: 768px, lg: 1024px, xl: 1280px, 2xl: 1440px
var BREAKPOINTS = {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    '2xl': 1440,
};
// Custom hook that uses matchMedia instead of useBreakpoint to avoid constant re-renders
var useMediaQuery = function (query) {
    var _a = useState(function () {
        if (!windowExists())
            return false;
        return window.matchMedia(query).matches;
    }), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        if (!windowExists())
            return undefined;
        var mediaQuery = window.matchMedia(query);
        var handler = function (event) {
            setMatches(event.matches);
        };
        // Modern browsers
        mediaQuery.addEventListener('change', handler);
        return function () {
            mediaQuery.removeEventListener('change', handler);
        };
    }, [query]);
    return matches;
};
export var useIsMobile = function () {
    var _a = useContext(ExperienceContext), channel = _a.channel, isConsumerApp = _a.isConsumerApp;
    var isMobileFromChannel = channel === 'mobile';
    var isMobileFromNativeApp = isConsumerApp;
    // const isMobileFromStencilHook = useBreakpoint('sm', { ssr: false }).exact; // Causes re-renders
    // Use matchMedia instead of useBreakpoint - only updates when crossing the breakpoint
    // 640px matches the 'sm' breakpoint.
    var isMobileFromMediaQuery = useMediaQuery("(max-width: ".concat(BREAKPOINTS.sm - 1, "px)"));
    var isMobile = isMobileFromChannel || isMobileFromNativeApp || isMobileFromMediaQuery;
    return useMemo(function () { return ({ isMobile: isMobile, channel: channel, isConsumerApp: isConsumerApp }); }, [isMobile]);
};
export var useIsTablet = function () {
    // Tablet is exactly sm, md, or lg breakpoints (640px-1023px)
    var isTablet = useMediaQuery("(min-width: ".concat(BREAKPOINTS.sm, "px) and (max-width: ").concat(BREAKPOINTS.lg - 1, "px)"));
    return useMemo(function () { return ({ isTablet: isTablet }); }, [isTablet]);
};
export var useIsDesktop = function () {
    // Desktop is greater than lg breakpoint (>= 1024px)
    var isDesktop = useMediaQuery("(min-width: ".concat(BREAKPOINTS.lg, "px)"));
    return useMemo(function () { return ({ isDesktop: isDesktop }); }, [isDesktop]);
};
